<template>
  <div class="m-5">
    <h1 class="h1 mb-2">{{ data?.title }}</h1>
    <vue-markdown
      class="prose max-w-none w-full"
      :source="data?.content || ''"
    ></vue-markdown>
  </div>
</template>

<script setup>
import VueMarkdown from 'vue-markdown-render'

definePageMeta({
  allowOnPartnerPage: true,
})
const { locale } = useI18n()
const { data } = await useStrapiSingleType(
  `/terms-and-conditions?locale=${locale.value}&pLevel`,
  {
    transform: ({ data = {} }) => data,
  }
)
</script>
